import { Tipologia } from "app/models/tipologias.model"

export class ActualizarColeccionModel{
  bienCulturalUuid: string
  gestionesUuid: string[]
  nuevaColeccion: Tipologia
  cambioNoRegistro: boolean
}